import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Plan } from '../plan.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class PlansResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  query(params?: QueryParams): Observable<Plan[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Plan[]>(`${this.apiRoot}/${account_id}/api/plans`, { params })),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Plan', downgradeInjectable(PlansResource));
